// Ключ в sessionStorage: «сессия истекла» — страница входа показывает пояснение и сбрасывает ключ.
export const SESSION_EXPIRED_KEY = 'sessionExpired';

/** Время окончания действия JWT в миллисекундах (поле exp) или null, если токен не удалось разобрать. */
export function getTokenExpiryMs(token?: string | null): number | null {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
    const exp = JSON.parse(json).exp;
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}

export function isTokenExpired(token?: string | null): boolean {
  const expiry = getTokenExpiryMs(token);
  // Если срок определить нельзя — не выбрасываем пользователя, пусть решит сервер (401)
  return expiry !== null && expiry <= Date.now();
}
